const styleId = 'customStyles';

export const addStylesToHead = (styles) => {
  const head = document.head || document.getElementsByTagName('head')[0];


  const style = document.createElement('style');

  head.appendChild(style);
  style.setAttribute('id', styleId);
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = styles;
  } else {
    style.appendChild(document.createTextNode(styles));
  }
};

export const extractProperty = (className, styleName) => {
  const stylesText = document.getElementById(styleId).innerHTML;
  if (stylesText) {
    const regex = new RegExp(`(?<=.${className}{)(.*?)(?=})`, 'g');
    let innerStyleText = stylesText.match(regex);
    if (innerStyleText && innerStyleText.length > 0 && innerStyleText[0]) {
      innerStyleText = innerStyleText[0];
      const regexStyle = new RegExp(`(?<=${styleName}:)(.*?)(?= !important;)`, 'g');
      const styleValue = innerStyleText.match(regexStyle);
      if (styleValue && styleValue.length > 0 && styleValue[0]) {
        return styleValue[0];
      }
    }
  }
  return null;
};

// Convert parameters to any class that is added by Triskele from properties API and return css styles
export const classNameTriskeleParser = (VisualName, VisualType, VisualCmpnt, VisualState = '') => {
  if (VisualName) {
    VisualName = VisualName.replace(' & ', 'And');
  }
  const obj = {
    VisualName, VisualType, VisualCmpnt, VisualState
  };
  return createClassName('', obj);
};

export const createClassName = (char, data) => {
  if (data && data.VisualName && data.VisualCmpnt !== undefined) {
    const name = char + data.VisualName.replaceAll(' ', '');
    const component = data.VisualCmpnt.replaceAll(' ', '');
    const state = data.VisualState
      ? data.VisualState.replaceAll(' ', '')
      : '';

    const type = data.VisualType.replaceAll(' ', '').replaceAll("'", '');
    return `${name}${component}${state}${type}`;
  }
  return '';
};
